import PropTypes from 'prop-types';
import { CUSTOMIZATION_ORIENTATIONS, CUSTOMIZATION_POSITIONS, CUSTOMIZATION_SIZES } from '../customization';

export const CustomizationPropTypes = {
	text: PropTypes.string,
	orientation: PropTypes.oneOf(Object.values(CUSTOMIZATION_ORIENTATIONS)),
	size: PropTypes.oneOf(Object.values(CUSTOMIZATION_SIZES)),
	signature: PropTypes.string,
	position: PropTypes.oneOf(Object.values(CUSTOMIZATION_POSITIONS)),
};
